import { useCallback, useEffect, useState } from "react"
import { MessageNotification } from "../shared/MessageNotification"
import type { ChatMessage } from "./useCallChat"
import type { ChatNotificationsPreference } from "./useCallPreferences"

/** Keep an unread preview visible until it is opened or dismissed, respecting the user's preference. */
export function useChatNotification({ enabled, isOpen, mode }: { enabled: boolean; isOpen: boolean; mode: ChatNotificationsPreference }) {
  const [message, setMessage] = useState<ChatMessage | null>(null)
  const dismiss = useCallback(() => setMessage(null), [])
  useEffect(() => {
    if (!enabled || mode === "never" || (isOpen && mode === "when-closed")) setMessage(null)
  }, [enabled, isOpen, mode])
  const notify = useCallback((incoming: ChatMessage) => {
    if (!enabled || mode === "never" || (isOpen && mode === "when-closed")) return
    setMessage(incoming)
  }, [enabled, isOpen, mode])
  return { message, notify, dismiss }
}

export function ChatNotification({ message, onOpen, onDismiss }: { message: ChatMessage | null; onOpen: () => void; onDismiss: () => void }) {
  if (!message) return null
  return <MessageNotification kind="room" senderName={message.name} body={message.text} onOpen={onOpen} onDismiss={onDismiss} />
}
